import React from "react";
import InputBox from "../Components/InputBox";
import SelectInput from "../Components/SelectInput";
import Label from "../Components/Label";
import { useSelector } from "react-redux";
import FileUploadAndView from "../../User/Components/FileUploadAndView";
import { v4 } from "uuid";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../utils/firebase/Firebase.utils";
import toast from "react-hot-toast";
import { setDocData } from "../../../utils/firebase/Firebase.utils";
import { useNavigate } from "react-router-dom";
import { dualNotification } from "../../../utils/EleghoUtils";
import { adminEmailAddress, unitNumberLabel } from "../../../utils/constants";

function AddConcernForm({ setAddMode }) {
  const currentUser = useSelector((state) => state.userObject);
  const [formData, setFormData] = React.useState({});
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [progress, setProgress] = React.useState(0);
  const [activeUpload, setActiveUpload] = React.useState(false);
  const [assignedId, setAssignedId] = React.useState(v4);
  const [files, setFiles] = React.useState({});

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const concernList = [
    "Electricity",
    "Water Supply",
    "Water Leaks",
    "Internet",
    "Violation",
    "Neighbors",
    "Cutting of Trees",
    "Defective Water Meter",
    "Others",
  ];

  const concernOptions = concernList.map((concern) => ({
    value: concern,
    label: concern,
  }));

  const handleUpload = (e, fileName) => {
    const file = e.target.files[0];
    setIsProcessing(true);
    const storageRef = ref(
      storage,
      `concerns/${assignedId}/${file.name} + ${v4()}`
    );
    const uploadTask = uploadBytesResumable(storageRef, file);
    setActiveUpload(fileName);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setFiles({
            ...files,
            [fileName]: downloadURL,
          });
          setFormData({ ...formData, [fileName]: downloadURL });
          setActiveUpload("");
          setIsProcessing(false);
        });
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    if (!formData.concern) {
      toast.error("Please select a concern");
      setIsProcessing(false);
      return;
    }

    if (!formData.description) {
      toast.error("Please enter a description");
      setIsProcessing(false);
      return;
    }

    const concernData = {
      identifier: formData.identifier,
      concern: formData.concern,
      description: formData.description,
      image: formData.image || "",
      video: formData.video || "",
      user: currentUser.email,
      createdBy: currentUser.displayName,
      uid: currentUser.uid,
      status: "Pending",
      createdAt: new Date().toLocaleString(),
      id: assignedId,
      email: currentUser.email,
    };

    await setDocData("concerns", assignedId, concernData);

    const notificationObject = {
      recipient: adminEmailAddress,
      recipientName: "Admin",
      sender: currentUser.email,
      senderName: currentUser.displayName,
      type: "concern",
      subject: "New Concern Filed",
      message: `A new concern has been filed by ${currentUser.displayName} of ${formData.identifier}.`,
      url: "/property-management?type=Concerns",
      id: assignedId,
    };

    await dualNotification(notificationObject);

    toast.success("Concern filed successfully");
    setIsProcessing(false);
    setAddMode(false);
  };

  return (
    <div className="relative small-form">
      <button className="close-button" onClick={() => setAddMode(false)}>
        Close
      </button>
      <div className="title-header">Add Concern</div>

      <form onSubmit={handleSubmit}>
        <div>
          <InputBox
            label={unitNumberLabel}
            name="identifier"
            value={formData.identifier}
            onChange={handleChange}
            placeholder={`Enter ${unitNumberLabel}`}
            required
          />
          <SelectInput
            options={concernOptions}
            label="Concern Type"
            name="concern"
            value={concernOptions.find(
              (option) => option.value === formData.concern
            )}
            onChange={(selectedOption) => {
              setFormData({ ...formData, concern: selectedOption.value });
            }}
            placeholder="Select concern type"
            required
          />
          <Label label="Description" />
          <textarea
            className="border p-2 border-gray-800 rounded-lg w-full focus:ring-2 focus:ring-[#8FCD00]/20 focus:border-[#8FCD00] transition-colors resize-none bg-gray-50"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Describe your concern"
            rows="4"
            required
          ></textarea>
          <div className="space-y-4">
            {/* Photo Upload */}
            <div className="bg-gray-50 rounded-md p-3">
              <FileUploadAndView
                doc="image"
                files={files}
                handleUpload={handleUpload}
                progress={progress}
                activeUpload={activeUpload}
              />
            </div>
            {/* Video Upload */}
            <div className="bg-gray-50 rounded-md p-3">
              <FileUploadAndView
                doc="video"
                files={files}
                handleUpload={handleUpload}
                progress={progress}
                activeUpload={activeUpload}
              />
            </div>
          </div>
          <button
            className="blue-button w-full mt-4"
            type="submit"
            disabled={
              isProcessing || !formData.concern || !formData.description
            }
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddConcernForm;
